// Store listings for the RoolDrive rider app.
export const APP_STORE_URL = 'https://apps.apple.com/us/app/rooldrive/id6756207703';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.rooldrive';
